import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class StreetsService {
  constructor(private http: HttpClient) {}

  public fetchStreets(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/streets`
    return this.http.post(url, params)
  }
  public fetchStreet(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/street/${id}`
    return this.http.get(url, {})
  }

  public deleteStreet(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/street/${id}`
    return this.http.delete(url)
  }

  public createStreet(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/street`
    return this.http.post(url, params)
  }

  public updateStreet(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/street/${id}`
    return this.http.put(url, params)
  }
}
